import type { DynamicIslandActivity } from '../../../context/dynamicIslandTypes'
import { ChromeToolbarButton, ChromeToolbarDangerButton } from '../../ChromeActions'
import { ThemeModal } from '../../ThemeModal'
import { themeDynamicIslandActionButtonClass } from './dynamicIslandTokens'
import { DynamicIslandActivityDetailContent } from './detail/DynamicIslandActivityDetailContent'
import { DynamicIslandActivityDetailShell } from './detail/DynamicIslandActivityDetailShell'

const islandActionBtn = themeDynamicIslandActionButtonClass()

const DETAIL_TRIGGER_ACTION_IDS = new Set(['detail', 'open'])

type Props = {
  open: boolean
  angular: boolean
  activities: DynamicIslandActivity[]
  selectedId: string | null
  onSelectId: (id: string) => void
  onClose: () => void
}

export function DynamicIslandActivityDetailModal({
  open,
  angular,
  activities,
  selectedId,
  onSelectId,
  onClose,
}: Props) {
  const activity =
    activities.find((item) => item.id === selectedId) ?? activities[0] ?? null
  if (!activity) return null

  const footerActions = activity.actions.filter((action) => !DETAIL_TRIGGER_ACTION_IDS.has(action.id))
  const multiSource = activities.length > 1
  const resolvedSelectedId = activity.id

  return (
    <ThemeModal
      open={open}
      onClose={onClose}
      title={multiSource ? '后台活动' : activity.sourceLabel}
      angular={angular}
      size="xl"
      stackLevel="island-overlay"
      bodyClassName="flex min-h-0 flex-1 flex-col overflow-hidden p-0"
      footer={
        footerActions.length > 0 ? (
          <div className="flex w-full flex-wrap justify-end gap-2">
            {footerActions.map((action) => {
              const Btn = action.variant === 'danger' ? ChromeToolbarDangerButton : ChromeToolbarButton
              return (
                <Btn
                  key={action.id}
                  type="button"
                  className={islandActionBtn}
                  disabled={action.disabled}
                  onClick={action.onClick}
                >
                  {action.label}
                </Btn>
              )
            })}
          </div>
        ) : undefined
      }
    >
      <DynamicIslandActivityDetailShell
        activities={activities}
        selectedId={resolvedSelectedId}
        onSelectId={onSelectId}
        angular={angular}
        renderContent={(item) => (
          <DynamicIslandActivityDetailContent activity={item} angular={angular} />
        )}
      />
    </ThemeModal>
  )
}
